import { t } from '../../app/i18n';

const types = {
  INACTIVE: 'INACTIVE',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  CONFIRMED: 'CONFIRMED',
};

export const translation = {
  [types.INACTIVE]: t('Neaktívna'),
  [types.PENDING_CONFIRMATION]: t('Čaká na schválenie'),
  [types.CONFIRMED]: t('Schválená'),
};

export default types;



// WEBPACK FOOTER //
// ./src/common/enums/contractStatus.js